import { directus } from "./directus";
import { createItem, withToken } from "@directus/sdk";

type SubmissionValueInput = {
  field: string;
  value: string;
  file?: string | null;
  sort: number;
};

type FormSubmitInput = {
  form: string;
  notificationEmail?: string | null;
  values: SubmissionValueInput[];
};

export const formSubmit = async (data: FormSubmitInput) => {
  const payload: Record<string, unknown> = {
    form: data.form,
    values: data.values.map((item) => ({
      field: item.field,
      value: item.value,
      sort: item.sort,
      ...(item.file ? { file: item.file } : {}),
    })),
  };

  if (data.notificationEmail) {
    payload.notification_email = data.notificationEmail;
  }

  return await directus.request(
    withToken(
      process.env.DIRECTUS_TOKEN || "",
      createItem("form_submissions", payload)
    )
  );
};

type SubmissionReturnType = {
  id: string;
};

export const isValidSubmission = (obj: unknown): obj is SubmissionReturnType =>
  !!obj && typeof obj === "object" && Object.hasOwn(obj, "id");

export const uploadFile = async (file: File): Promise<string | null> => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const DIRECTUS_HOST = process.env.DIRECTUS_HOST;
    const DIRECTUS_TOKEN = process.env.DIRECTUS_TOKEN;

    if (!DIRECTUS_HOST || !DIRECTUS_TOKEN) {
      throw new Error("Directus configuration is missing");
    }

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 60_000);

    const response = await fetch(`${DIRECTUS_HOST}/files`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${DIRECTUS_TOKEN}`,
      },
      body: formData,
      signal: controller.signal,
    });

    clearTimeout(timeoutId);

    if (!response.ok) {
      throw new Error("File upload failed");
    }

    const responseData = await response.json();
    return responseData.data?.id || null;
  } catch (error) {
    if (process.env.NODE_ENV !== "production") {
      console.error("File upload error:", error);
    }
    return null;
  }
};
